import { Box, Typography } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import { EContainerStatus } from '~/src/repositories/Container'
import { useTranslation } from 'react-i18next'

interface ContainerChipProps {
  status: EContainerStatus
}

export const ContainerChip: React.FC<ContainerChipProps> = ({ status }) => {
  const { t } = useTranslation()
  let text = ''
  switch (status) {
    case EContainerStatus.BEFORE_DEPOSIT:
      text = t('container_order.deposit_payment_yet')
      break
    case EContainerStatus.DEPOSITED:
      text = t('container_order.deposit_payment_done')
      break
    case EContainerStatus.SOLD:
      text = t('container_order.sold')
      break
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'rgba(0, 0, 0, 0.87)',
        padding: '3px 4px',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        boxSizing: 'border-box',
        borderRadius: '16px',
        height: '24px',
      }}
    >
      <DoneIcon sx={{ color: '#666666', fontSize: '15px' }} />
      <Typography
        sx={{
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '13px',
          lineHeight: '18px',
          letterSpacing: '0.16px',
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}
